<template>
  <div class="content">
    <el-tabs class="tabLv3" type="border-card" v-model="tabName">
      <i class="lt"></i>
      <i class="rt"></i>
      <el-tab-pane name="myAgent">
        <span slot="label">
          <i class="iconfont iconcheck"></i>
          <i class="border"></i> 我的待办
        </span>
        <div class="w_normalNav">
          <button class="BlueSmBtn" @click="subSeefrom">搜索</button>
          <button class="OrangeSmBtn" @click="reset">重置</button>
        </div>
        <div class="searchForm1">
          <searchForm :items="items" :formPlus="form_jsgl" ref="searchForm_jsgl">
            <template slot="last">
              <el-form-item label="计划名称">
                <el-input placeholder="请输入计划名称" v-model="seefrom.name"></el-input>
              </el-form-item>
              <el-form-item label="管理层级">
                <el-select placeholder="请选择" v-model="seefrom.ma_id">
                  <el-option v-for="item in Hierarchy" :key="item.id" :value="item.id" :label="item.name"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="任务编号">
                <el-input placeholder="请输入计划名称" v-model="seefrom.number"></el-input>
              </el-form-item>
              <el-form-item label="任务状态">
                <el-select placeholder="请选择" v-model="seefrom.status">
                  <el-option v-for="item in missionStatus" :key="item.id" :value="item.id" :label="item.label"></el-option>
                </el-select>
              </el-form-item>
            </template>
          </searchForm>
        </div>
        <el-table class="stripeTable" :data="tableData" height="470">
          <el-table-column label="任务编号" prop="number"></el-table-column>
          <el-table-column label="计划名称" prop="programName"></el-table-column>
          <el-table-column label="管理层级" prop="maName"></el-table-column>
          <el-table-column label="处理人" prop="userName"></el-table-column>
          <el-table-column label="任务内容" prop="content"></el-table-column>
          <!-- <el-table-column label="当前周期" prop="now_period"></el-table-column> -->
          <!-- <el-table-column label="周期区间" prop="period"></el-table-column> -->
          <el-table-column label="状态" width="120">
            <template slot-scope="scope">
              <span v-if="scope.row.status === 0">处理中</span>
              <span v-if="scope.row.status === 1">已完成</span>
              <span v-if="scope.row.status === 2">已过期</span>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="300">
            <template slot-scope="scope">
              <el-link icon="iconfont iconxz" type="text" size="small" @click="upload(scope.$index, scope.row)">上传文件</el-link>
              <el-link icon="iconfont iconcheck" type="text" size="small" @click="see(scope.$index, scope.row, true)">详情</el-link>
              <el-link v-if="scope.row.status === 0" icon="iconfont iconedit" type="text" size="small" @click="myHandle(scope.$index, scope.row, true)">处理</el-link>
            </template>
          </el-table-column>
        </el-table>
        <div class="footer">
          <el-pagination :total="total" :page-size="pageSize" :current-page.sync="pageNum" @current-change="handleCurrentChange" layout="prev, pager, next"></el-pagination>
        </div>
        <!-- dialog -->
        <el-dialog class="editDialog" :visible.sync="displayForm" :title="title" :close-on-click-modal="false">
          <el-form class="w_myagent">
            <el-form-item label="计划名称：" prop="name">
              <span>{{ this.Details.programName }}</span>
            </el-form-item>
            <el-form-item label="任务内容：" prop="remark">
              <span>{{ this.Details.content }}</span>
            </el-form-item>
            <el-form-item label="处理详情：" prop="hierarchy">
              <span>{{ this.Details.remark }}</span>
            </el-form-item>
            <el-form-item label="任务状态：" prop="cycle">
              <span v-if="this.Details.status === 0">待处理</span>
              <span v-if="this.Details.status === 1">已处理</span>
              <span v-if="this.Details.status === 2">已过期</span>
            </el-form-item>
          </el-form>
        </el-dialog>
        <!-- 处理弹框 -->
        <el-dialog class="editDialog" :visible.sync="displayEditForm" :title="title" :close-on-click-modal="false">
          <el-form ref="handle" :model="handle">
            <el-form-item label="处理结果：" prop="remark" :rules="[
                {
                  required: true,
                  message: '处理结果不能为空',
                  trigger: 'blur',
                },
              ]">
              <el-input placeholder="请输入处理结果" type="textarea" v-model="handle.remark"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="displayEditForm = false">取 消</el-button>
            <el-button class="confirmButton" type="primary" @click="submitForm">确 定</el-button>
          </div>
        </el-dialog>
        <!-- 上传文件 -->
        <el-dialog class="editDialog" :visible.sync="UpdisplayForm" :title="title" :close-on-click-modal="false">
          <el-table class="stripeTable" :data="MessageData">
            <el-table-column label="文件名称" prop="name"></el-table-column>
            <el-table-column label="上传时间" prop="create_time"></el-table-column>
            <el-table-column label="操作" width="200">
              <template slot-scope="scope">
                <el-link icon="iconfont icondelete" type="text" size="small" @click="deleteMsg(scope.$index, scope.row)">删除</el-link>
                <el-link :href="process.env.fileUrl + '/' + scope.row.url" icon="iconfont iconcheck" type="text" size="small" target="_blank" download="document">查看</el-link>
              </template>
            </el-table-column>
          </el-table>
          <el-form>
            <el-form-item>
              <input type="file" ref="clearFile" @change="getFile($event)" multiple="multiplt" class="add-file-right-input" style="display: inline-block, margin-top:20px;" />
              <!-- <button class="confirmButton" @click="confirmUp">确认上传</button> -->
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button class="cancelButton" @click="UpdisplayForm = false">取 消</el-button>
            <el-button class="uploadButton" type="primary" @click="confirmUp">确认上传</el-button>
          </div>
        </el-dialog>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
export default {
  data() {
    return {
      hrefUrl: '',
      //表格
      tableData: [],
      MessageData: [],
      //详情
      Details: [],
      tabName: 'myAgent',
      loading: true,
      form_jsgl: {},
      displayForm: false,
      displayEditForm: false,
      UpdisplayForm: false,
      showTable: true,
      //用户ID
      userId: '',
      items: [],
      loadingStatus: false,
      //弹框标题
      title: '',
      status: '',
      seefrom: {
        name: '',
        ma_id: '',
        number: '',
        status: '',
      },
      Hierarchy: [],
      //任务状态
      missionStatus: [
        { id: 0, label: '待处理' },
        { id: 1, label: '已处理' },
        { id: 2, label: '已过期' },
      ],
      //上传文件
      addArr: [],
      url: [],
      //处理结果
      handle: {
        remark: '',
      },
      handle_id: '',
      //分页
      pageNum: 1,
      pageSize: 10,
      total: '',
    }
  },
  computed: {
    self() {
      return this
    },
    config() {
      return [
        {
          prop: 'number',
          label: '任务编号',
        },
        {
          prop: 'programName',
          label: '计划名称',
        },
        {
          prop: 'maName',
          label: '管理层级',
        },
        {
          prop: 'userName',
          label: '处理人',
        },
        {
          prop: 'content',
          label: '任务内容',
        },
        // {
        //   prop: "now_period",
        //   label: "当前周期"
        // }
        // {
        //   prop: "period",
        //   label: "周期区间"
        // }
      ]
    },
    dt() {
      return dt.map(({ label }) => label)
    },
  },
  components: {
    normalNav: () => import('public/normalNav'),
    searchForm: () => import('public/searchForm'),
    easyTable: () => import('public/easyTable'),
  },
  methods: {
    //搜索
    subSeefrom() {
      this.initUserId()
    },
    //重置
    reset() {
      this.seefrom.name = ''
      this.seefrom.ma_id = ''
      this.seefrom.number = ''
      this.seefrom.status = ''
    },
    //上传文件
    upload(index, row) {
      this.UpdisplayForm = true
      this.title = '上传文件'
      this.up_id = row.id
      this.initUpTable()
    },
    //上传文件--表格数据
    initUpTable() {
      this.$axiosget('operation/tasktab/findAllFile', {
        params: {
          tasktab_id: this.up_id,
        },
      }).then((res) => {
        this.MessageData = res.data.data
      })
    },
    //上传文件--前台获取上传文件
    //上传文件
    getFile(event) {
      var file = event.target.files
      this.addArr = []
      var imgName = file[file.length - 1].name
      var idx = imgName.lastIndexOf('.')
      if (idx != -1) {
        var ext = imgName.substr(idx + 1).toUpperCase()
        ext = ext.toLowerCase()
        if (ext != 'txt') {
          this.addArr = file[file.length - 1]
          //console.log(this.addArr, "addArr");
        } else {
          this.$message.error('文件类型错误！')
        }
      }
    },
    //上传文件--确认上传
    confirmUp() {
      if (this.addArr.length === 0) {
        this.$message({
          type: 'info',
          message: '请选择要上传的文件',
        })
        return
      }

      var formData = new FormData()
      // for (var i = 0; i < this.addArr.length; i++) {
      //   formData.append("file", this.addArr[i]);
      // }
      formData.append('file', this.addArr)
      if (process.env.NODE_ENV === 'development') {
        formData.append('prefix', 'test')
      }
      this.$http.post('http://39.100.67.126:1211/file/upload', formData).then((res) => {
        this.url = res.data.data
        // for (var j = 0; j < this.addArr.length; j++) {
        this.$axiospost('operation/tasktab/saveFile', {
          name: this.addArr.name,
          url: this.url[0],
          tasktab_id: this.up_id,
        }).then((res) => {
          this.$message.success('上传成功！')
          this.initUpTable()
          this.addArr = []
          this.$refs.clearFile.value = ''
        })
        // }
      })
    },
    //上传文件--查看
    // seeDoc(index, row) {
    //   let urlH = 'http://39.100.67.126:1212/file/' + row.url;
    //   fetch(urlH).then(res => res.blob()).then(blob => {
    //     this.hrefUrl = URL.createObjectURL(blob)
    //   })
    // },
    //上传文件--删除
    deleteMsg(index, row) {
      this.$confirm('是否删除该文件？', '删除操作', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(() => {
        this.$axiosdelete('operation/tasktab/deleteFile', {
          params: {
            id: row.id,
          },
        }).then((res) => {
          this.$message.success('删除成功!')
          this.initUpTable()
        })
      })
    },
    //查看
    see(index, row) {
      this.title = '任务详情'
      this.displayForm = true
      this.Details = row
    },
    //处理
    myHandle(index, row) {
      this.title = '任务处理'
      this.displayEditForm = true
      this.handle_id = row.id
      this.remark = ''
    },
    //处理--确认
    submitForm() {
      this.$refs.handle.validate((valid) => {
        if (valid) {
          var formData = new FormData()
          formData.append('remark', this.handle.remark)
          formData.append('id', this.handle_id)
          this.$axiospost('operation/tasktab/handleTask', formData).then((res) => {
            this.$message.success('处理成功！')
            this.displayEditForm = false
            this.initUserId()
          })
        }
      })
    },
    handleCurrentChange(val) {
      this.initUserId(val)
    },
    //用户ID\表格数据
    initUserId(val) {
      this.$axiosget('operation/tasktab/findUser', {
        params: {
          userCount: localStorage.getItem('userphone'),
        },
      }).then((res) => {
        this.userId = res.data.data.id
        this.$axiosget('operation/tasktab/findAll', {
          params: {
            pageNum: val ? val : this.pageNum,
            pageSize: this.pageSize,
            name: this.seefrom.name,
            ma_id: this.seefrom.ma_id,
            number: this.seefrom.number,
            status: this.seefrom.status,
            user_id: this.userId,
          },
        }).then((Response) => {
          this.total = Response.data.data.total ? Number(Response.data.data.total) : 0
          this.tableData = Response.data.data.list
        })
      })
    },

    //管理层级
    initManagement() {
      this.$axiosget('operation/management/findAll', {
        params: {
          pageNum: 1,
          pageSize: 1000,
        },
      }).then((res) => {
        this.Hierarchy = res.data.data.list
        //console.log(this.Hierarchy, "管理层级");
      })
    },
  },
  created() {
    this.initManagement()
    this.initUserId()
  },
}
</script>

<style lang="less" scoped>
.w_normalNav {
  padding-top: 10px;
  height: 52px;
  position: absolute;
  top: -52px;
  right: 32px;
  z-index: 99;
}
.el-textarea__inner {
  border: 1px solid #3d4963;
  border-radius: 0;
  width: 310px;
  background: transparent;
  color: #cacaca;
}
.el-input__inner:focus {
  border: 1px solid #3587c7;
}
.w_myagent {
  margin-bottom: 30px;
  .el-form-item__content {
    width: 310px;
    span {
      display: inline-block;
    }
  }
}
.uploadButton {
  width: 80px;
  height: 32px;
  line-height: 32px;
  padding: 0;
  font-size: 16px;
  background: #306ac9 !important;
  border: 0 none;
  color: #fff;
}
</style>



// WEBPACK FOOTER //
// src/components/dynamicRoute3/management/mission/myAgent.vue